import BlogDetailFooter from "./BlogDetailFooter";

export default function BlogDetailPageFooter({data}) {
    return(
        <>
            <BlogDetailFooter data={data}></BlogDetailFooter>
        </>
    )
}